export default __webpack_public_path__ + "static/media/FP-1.8b95208a.png";